const toMajorUnits = (amountInMinorUnits: number) => amountInMinorUnits / 100;

export default toMajorUnits;
